<ng-container [formGroup]="form">
	<mat-form-field>
		<input
			autocomplete="off"
			matInput
			placeholder="Sub Code"
			formControlName="code"
			maxlength="100"
			required
		/>
	</mat-form-field>
</ng-container>
